import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import SelectReact from "react-select";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ChildEvents from "./child-events/child-events";
import { compose } from "redux";
import { withApiService } from "../../../hoc";
import { useDispatch, useSelector } from "react-redux";
import noAvatar from "../../../icon/profileAvatar.svg";
import {
  childRequest,
  childUpdate,
  childCreate,
  childDelete,
  createHistoryChild,
} from "../../../../store/actions/child";
import {
  clientLoaded,
  updateClientFromChild,
} from "../../../../store/actions/client";
import "./child.scss";
import { DateOperations } from "../../../utils-function/date-operations";
import { NoData } from "../../../utils-function/no-data";
import { fetchGroups, scheduleGroup } from "../../../../store/actions/selects";
import {
  createInvoiceAdmin,
  invoiceLoaded,
} from "../../../../store/actions/invoice";
import SelectOptions from "../../../modal-components/select-options";
import { withRouter } from "react-router";
import ConfirmDelete from "../../../modal-components/modal-confirm-delete";
import SaveDocument from "../../../../.ClientOffice/components/modal/save-document";
import Badge from "@material-ui/core/Badge";
import { ReactComponent as Add } from "../../../icon/add.svg";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import ChangePhoto from "../../../../.ClientOffice/components/modal/changePhoto";

const useStyles = (theme) => ({
  root: {
    width: "400px",
    height: "250px",
    padding: "0 15px",
  },
  titleDialog: {
    textAlign: "center",
  },
  btnDialog: {
    backgroundColor: "#C7C7C7",
    color: "white",
    fontSize: "0.75rem",
    height: "32px",
  },
  trainingHeader: {},
  trainingHeaderData: {
    display: "grid",
    gridAutoFlow: "column",
    gridGap: theme.spacing(1),
  },
  radio: {
    marginTop: "30px",
  },
  iconHover: {
    color: "#F89A2B",
    "&:hover": {
      color: "red",
    },
  },
  btnChild: {
    backgroundColor: "#81CC5E",
    color: "white",
    marginRight: "30px",
  },
  status_id: {
    width: "150px",
  },
  new_status_id: {
    width: "100px",
  },
  textFields: {
    color: "#858585",
    fontSize: "16px",
    backgroundColor: "#FFFFFF",
    height: "30px",
    marginLeft: 15,
  },
  textFieldsBirthday: {
    color: "#858585",
    fontSize: "14px",
    backgroundColor: "#FFFFFF",
    height: "30px",
    marginLeft: 15,
  },
  badge: {
    backgroundColor: "#858585",
  },
});

const StyleChip = withStyles({
  root: {
    border: "1px solid #4594CC",
    marginRight: 14,
    marginBottom: 14,
    fontSize: 12,
    fontWeight: 700,
    fontFamily: "AppleGothic, sans-serif",
    paddingRight: 12,
    letterSpacing: "0.03rem",
  },
  colorPrimary: {
    backgroundColor: "#4594CC",
  },
  outlinedPrimary: {
    backgroundColor: "#FFFFFF",
  },
})(Chip);

const customMultiInputStyles = {
  control: (styles) => ({
    ...styles,
    padding: 0,
    backgroundColor: "#FFFFFF",
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    backgroundColor: "#FFFFFF",
    color: "#858585",
    fontSize: "14px",
    padding: 0,
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    backgroundColor: "#FFFFFF",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#858585",
    padding: "0 5px 0 0",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: 0,
  }),
};

export const SpinnerLocal = () => {
  return (
    <Container>
      <Grid container alignItems={"center"} justifyContent={"center"}>
        <CircularProgress />
      </Grid>
    </Container>
  );
};

const Child = (props) => {
  const { classes } = props;
  const dispatch = useDispatch();
  const groups = useSelector((state) => state.selects.groups);
  const invoiceDiscount = useSelector(
    (state) => state.discount.invoiceDiscount
  );
  const status_children = useSelector(
    (state) => state.children.status_children
  );
  const loading = useSelector((state) => state.children.loading);
  const child = useSelector((state) => state.children.child);
  const createDialogForm = {
    first_name: "",
    last_name: "",
    middle_name: "",
    birthday: "2019-01-01",
    sex: "male",
    status_id: 2,
    aux: [],
    trainers_id: "",
    filial_id: "",
    first_train: "",
    group_ids: [],
  };
  const { client } = props;
  const [openDocument, setOpenDocument] = useState(false);
  const [openPhoto, setOpenPhoto] = useState(false);
  const [showBtn, setShowBtn] = useState(false);
  const [showResidual, setShowResidual] = useState(false);
  const [residual, setResidual] = useState(client?.residual || 0);
  const [openDelete, setOpenDelete] = useState(false);
  const [openCreateInvoice, setOpenCreateInvoice] = useState(false);
  const [childSelected, setChildSelected] = useState(null);
  const [history, setHistory] = useState({ content: "" });
  const collection = "Children.photo";

  const loadFirstChild = () => {
    if (client && client.children && client.children.length > 0) {
      const id = client.children[0].id;
      dispatch(childRequest(id));
    } else return null;
  };
  const loadLinkChild = () => {
    const id = props.location.state.child_id;
    dispatch(childRequest(id));
  };

  useEffect(() => {
    if (groups.length === 0) {
      dispatch(fetchGroups());
    }
    if (props.location.state) {
      loadLinkChild();
    } else loadFirstChild();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, groups, props.location.state]);

  useEffect(() => {
    setChildSelected(child);
  }, [child]);

  const setStatusId = (name) => {
    setShowBtn(true);
    setChildSelected({ ...childSelected, status_id: name.id });
  };

  const handleChanged = (field) => {
    setShowBtn(true);
    setChildSelected({ ...childSelected, ...field });
  };

  const handleChangedResidual = (field) => {
    setShowResidual(true);
    setResidual(field);
  };

  const saveChangesChildren = () => {
    updateDataChildren();
    setShowBtn(false);
    setShowResidual(false);
  };

  const updateDataChildren = () => {
    props.openSave(true);
    dispatch(
      childUpdate({
        ...childSelected,
        group_ids: childSelected.groups.map((el) => el.id),
        residual_training:
          childSelected.residual_training === ""
            ? 0
            : Number(childSelected.residual_training),
      })
    );
  };

  const handleChangeGroups = (groups) => {
    setShowBtn(true);
    if (groups !== null) {
      const group_ids = groups?.map((item) => item.id);
      setChildSelected({ ...childSelected, groups, group_ids });
    } else setChildSelected({ ...childSelected, groups: [], group_ids: [] });
  };

  const setChild = (item) => {
    dispatch(childRequest(item.id));
    setShowBtn(false);
  };

  const createChild = () => {
    dispatch(
      childCreate({
        ...createDialogForm,
        client_id: props.client.id,
        last_name: "",
        first_name: "Имя",
        status_id: 4,
      })
    );
  };
  const deleteChild = () => {
    dispatch(childDelete(child));
  };

  const openCreateInvoiceDialog = (value) => {
    setOpenCreateInvoice(value);
    dispatch(invoiceLoaded({}));
    dispatch(scheduleGroup([]));
  };

  const addEventChild = () => {
    const payload = {
      ...history,
      id: childSelected.id,
      client_id: childSelected.client_id,
    };
    const required = "children";
    dispatch(createHistoryChild(required, payload));
    setHistory({ ...history, content: "" });
  };

  const onCloseChangedHistory = () => {
    setHistory({ ...history, content: "" });
  };

  const updateClientResidual = () => {
    dispatch(
      updateClientFromChild({
        ...client,
        residual: Number(residual),
      })
    );
    setShowResidual(false);
  };

  const closeChildAppend = () => {
    dispatch(clientLoaded(null));
  };
  const createInvoiceChild = (invoice) => {
    const newInvoice = {
      children_id: invoice.children_id,
      estimation: invoice.estimation,
      group_id: invoice.group_id,
      schedule_ids: invoice.valid.map((el) => el.id),
      is_refundable: invoice.is_refundable
    };
    dispatch(
      createInvoiceAdmin({
        ...newInvoice,
      })
    );
    if (newInvoice?.estimation === false) {
      openCreateInvoiceDialog(false);
    }
  };

  if (!client) {
    return null;
  }
  if (client.children.length === 0) {
    return (
      <Container>
        <Add onClick={() => createChild()} style={{ cursor: "pointer" }} />
        <Grid
          container
          style={{
            width: "100%",
            overflow: "hidden",
          }}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <NoData />
        </Grid>
      </Container>
    );
  }

  return (
    <Box display="flex" flexDirection="column" p={2}>
      <Box display="flex" mb={1} alignItems="center" sx={{ flexWrap: "wrap" }}>
        {client?.children?.map((item) => (
          <StyleChip
            key={item.id}
            avatar={
              <Avatar
                style={{
                  backgroundColor: "#FFFFFF",
                  color: "#4594CC",
                  fontWeight: 700,
                  border: "1px solid #4594CC",
                  marginRight: 12,
                }}
              >
                {item.first_name?.charAt(0)}
                {item.last_name?.charAt(0)}
              </Avatar>
            }
            label={`${item.first_name} ${item.last_name || ""}`}
            clickable
            color="primary"
            variant={item.id === child?.id ? "default" : "outlined"}
            onClick={() => setChild(item)}
          />
        ))}
        <Add
          onClick={() => createChild()}
          style={{ cursor: "pointer", marginBottom: 14 }}
        />
      </Box>
      {childSelected && !loading ? (
        <>
          <Box className="childContentInfo">
            <Box className="childBlockItem">
              <Box className="childBlock">
                <label>Имя</label>
                <TextField
                  margin="dense"
                  variant="outlined"
                  value={childSelected.first_name || ""}
                  onChange={(e) => {
                    handleChanged({ first_name: e.target.value });
                  }}
                  InputProps={{
                    className: classes.textFields,
                  }}
                />
              </Box>
              <Box className="childBlock">
                <label>Фамилия</label>
                <TextField
                  margin="dense"
                  variant="outlined"
                  value={childSelected.last_name || ""}
                  onChange={(e) => handleChanged({ last_name: e.target.value })}
                  InputProps={{
                    className: classes.textFields,
                  }}
                />
              </Box>
              <Box className="childBlock">
                <label>Отчество</label>
                <TextField
                  margin="dense"
                  variant="outlined"
                  value={childSelected.middle_name || ""}
                  onChange={(e) =>
                    handleChanged({ middle_name: e.target.value })
                  }
                  InputProps={{
                    className: classes.textFields,
                  }}
                />
              </Box>
              <Box className="childBlock">
                <label>Возраст</label>
                <TextField
                  margin="dense"
                  type="date"
                  variant="outlined"
                  className="textFieldsBirthday"
                  InputProps={{
                    className: classes.textFieldsBirthday,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={childSelected.birthday || ""}
                  onChange={(e) => handleChanged({ birthday: e.target.value })}
                />
                {childSelected.birthday ? (
                  <Box className="age">
                    {DateOperations({ birthday: childSelected.birthday }) >
                    4 ? (
                      <>
                        <DateOperations birthday={childSelected.birthday} /> лет
                      </>
                    ) : (
                      <>
                        <DateOperations birthday={childSelected.birthday} />{" "}
                        года
                      </>
                    )}
                  </Box>
                ) : null}
              </Box>
            </Box>
            <Box className="childBlockItem childBlockItemRight">
              <FormControl className="formChildSelect">
                <Box className="childBlock">
                  <label>Пол</label>
                  <Select
                    className="childSelect"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={childSelected.sex}
                    variant="outlined"
                    onChange={(e) => handleChanged({ sex: e.target.value })}
                  >
                    <MenuItem value={childSelected.sex} disabled>
                      {childSelected.sex}
                    </MenuItem>
                    <MenuItem value="male">муж.</MenuItem>
                    <MenuItem value="female">жен.</MenuItem>
                  </Select>
                </Box>
              </FormControl>
              <Box className="childBlock statusId">
                <label>Статус</label>
                <SelectOptions
                  items={status_children}
                  setValue={setStatusId}
                  value={status_children.find(
                    (el) => el.id === childSelected.status_id
                  )}
                  className={classes.status_id}
                />
              </Box>
              <Box
                className="childBlock childBlockRight"
                sx={{ marginTop: "20px" }}
              >
                <label>Группа</label>
                <SelectReact
                  placeholder="Выбрать..."
                  className="selects"
                  name="groups"
                  isMulti
                  value={childSelected.groups}
                  getOptionLabel={(x) => x.name}
                  getOptionValue={(x) => x.name}
                  options={groups}
                  components={{
                    ClearIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                  isDisabled={client.status_id === 3 || client.status_id === 4}
                  styles={customMultiInputStyles}
                  onChange={handleChangeGroups}
                />
              </Box>
            </Box>
            <Box className="actionChildElement">
              <DeleteIcon
                onClick={() => setOpenDelete(!openDelete)}
                className="deleteIconChild"
              />
              {showBtn ? (
                <Box className="doneChildBox" onClick={saveChangesChildren}>
                  <CheckCircleIcon className="doneChild" />
                </Box>
              ) : null}
              <Box className="editAvatarChild">
                <div
                  className="avatarChild"
                  onClick={() => setOpenPhoto(!openPhoto)}
                  style={{
                    backgroundImage: `url(${
                      child.avatar?.full_url || noAvatar
                    })`,
                  }}
                />
                <Box className="editDocumentsChild">
                  {child.documents?.length > 0 ? (
                    <Badge
                      color="secondary"
                      badgeContent={child.documents.length}
                      classes={{ badge: classes.badge }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => setOpenDocument(true)}
                      >
                        DOC
                      </Button>
                    </Badge>
                  ) : (
                    <Button
                      variant="contained"
                      onClick={() => setOpenDocument(true)}
                    >
                      DOC
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          <ChildEvents
            history={childSelected?.history || []}
            invoices={childSelected?.invoices || []}
            child={childSelected}
            status_id={child.status_id}
            invoiceDialog={openCreateInvoice}
            openCreateInvoiceDialog={openCreateInvoiceDialog}
            groupsPlan={childSelected.groups}
            children_id={childSelected.id}
            createInvoice={createInvoiceChild}
            invoiceDiscount={invoiceDiscount}
            addEventChild={addEventChild}
            handleChangedHistory={setHistory}
            historyChild={history}
            onCloseChangedHistory={onCloseChangedHistory}
            saveChangesChildren={saveChangesChildren}
            showResidual={showResidual}
            residual={residual}
            handleChanged={handleChangedResidual}
            updateClientResidual={updateClientResidual}
            closeChildAppend={closeChildAppend}
          />
        </>
      ) : (
        <SpinnerLocal />
      )}
      <ConfirmDelete
        state={openDelete}
        close={() => setOpenDelete(!openDelete)}
        func={deleteChild}
        id={child?.id}
      />
      {openDocument && (
        <SaveDocument
          open={openDocument}
          setOpen={setOpenDocument}
          child={child}
          client_id={child?.client.id}
        />
      )}
      {openPhoto && (
        <ChangePhoto
          open={openPhoto}
          admin={"admin"}
          setOpen={setOpenPhoto}
          item={child}
          collection={collection}
        />
      )}
    </Box>
  );
};

export default compose(
  withApiService(),
  withStyles(useStyles)
)(withRouter(Child));
